define('views/abstract-comments/comment',[
  "globals",
  "backbone",
  "./edit-form"
], function (globals, Backbone, EditFormView) {
  "use strict";

  return Backbone.View.extend({
    tagName: "article",
    attributes: { role: "comment" },
    deleteMessage: Messages("comment.delete.confirm"),

    events: {
      "click [data-action = delete]": "destroy",
      "click [data-action = edit]": "edit"
    },

    initialize: function () {
      this.model.on("destroy", this.remove, this);
      this.model.on("change", this.render, this);

      if (_.has(globals, "content")) {
        this.listenTo(globals.content, "change:location", this.remove);
      }
    },

    
    render: function () {
      var attachment = "";
      if(this.model.attributes.hasOwnProperty("attachment") && this.model.attributes.attachment != "") {
        attachment = this.model.attributes.attachment
      }
      
      this.$el.html(this.template(
        _.extend(this.model.toFormattedJSON(), 
        {
          attachment: attachment
        },
        {
          currentUser: {
            id: $("body").data("user-id"),
            role: $("body").data("user-role")
          }
        })
      ));

      return this;
    },

    edit: function (e) {
      e.preventDefault();

      var editFormView = new EditFormView({
        model: this.model,
        collection: this.collection,
        el: this.$editForm.clone()
      });

      this.listenToOnce(editFormView, "reset", this.reset);
      this.$(".comment-body").hide();
      this.$el.prepend(editFormView.render().el);
      this.$el.find("attachment-indicator").val(this.model.get("content"));

      return this;
    },

    reset: function () {
      this.$(".comment-form").remove();
      this.$(".comment-body").show();
      return this;
    },

    destroy: function (e) {
      e.preventDefault();

      if (window.confirm(this.deleteMessage)) {
        this.model.destroy();
        $(document.getElementById(this.model.attributes.created)).remove();
      }

      return this;
    }
  });
});

